import {Box, DropdownItem} from '@viptech/react-components'
import {useEffect, useState} from 'react'
import AppReloadButton from 'src/components/appReloadButton/AppReloadButton'
import {ResponsiveBox} from 'src/layouts/main-layout/LayoutBase'
import {SelectWithSearchComponent} from '../../../../components/selectWithSearchComponent/SelectWithSearchComponent'
import TopBar from '../../../../components/top-bar/TopBar'
import {useQueryParams} from '../../../../hooks/useQuery'
import {FilterEventsType} from '../../../../services/api'

const searchTypes = [
  {id: 'clientName', label: 'Nome do Local'},
  {id: 'id', label: 'ID'},
  {id: 'macAddress', label: 'MAC Address'},
]

export type SearchTypeEdgeServers = {
  clientName?: string
  id?: number
  macAddress?: string
}

type Props = {
  filter?: FilterEventsType
  setFilter?: React.Dispatch<React.SetStateAction<FilterEventsType>>
  search: SearchTypeEdgeServers
  setSearch: (search: SearchTypeEdgeServers) => void
  refetch: () => void
  loading: boolean
}

export const TobBarHeader = (props: Props) => {
  const {setSearch, refetch, loading} = props

  const query = useQueryParams()

  const [searchSelected, setSearchSelected] = useState<DropdownItem>({id: '', label: ''})
  const [inputAlarmSearch, setInputAlarmSearch] = useState<string>('')

  async function handleSearchInput() {
    if (searchSelected.id && inputAlarmSearch) {
      setSearch({
        [searchSelected.id]: inputAlarmSearch,
      })
    } else if (searchSelected.id && !inputAlarmSearch) {
      setSearch({[searchSelected.id]: undefined})
    }
  }

  useEffect(() => {
    handleSearchInput()
  }, [searchSelected, inputAlarmSearch])

  useEffect(() => {
    const hasIdQuery = query.get('id')

    if (hasIdQuery) {
      setSearchSelected({id: 'id', label: 'ID'})
      setInputAlarmSearch(hasIdQuery)
    }
  }, [])

  return (
    <TopBar>
      <ResponsiveBox>
        <Box display='flex' columnGap='16px'>
          <AppReloadButton loading={loading} onClick={() => refetch()} />

          <SelectWithSearchComponent
            widthOnSelect='250px'
            searchBy={searchTypes}
            setSearchSelected={setSearchSelected}
            searchSelected={searchSelected}
            inputValue={inputAlarmSearch}
            inputSearch={setInputAlarmSearch}
            hideAdvancedFilters
          />
        </Box>
      </ResponsiveBox>
    </TopBar>
  )
}
